const adminSetupTour = {
  id: 'admin-setup',
  title: 'Companies and users',
  summary: 'Set up a company and invite people to it.',
  match: '/dashboard/yawn/company,/dashboard/yawn/user',
  autoStart: false,
  version: 1,
  steps: [
    {
      target: 'companies-add',
      title: 'Create the company first',
      body: 'A user has to belong to a company. Click "Add New", enter the details and verify it.',
      placement: 'left',
      optional: true,
    },
    {
      target: 'companies-verify',
      title: 'Verify it',
      body: 'Verified companies can be assigned users and linked to products.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'users-invite',
      title: 'Invite the user',
      body: 'Enter their email and assign them to a company. They will get a registration invite.',
      placement: 'left',
      optional: true,
    },
  ],
};

export default adminSetupTour;
